// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__DINJU","name":"Header_name__2dGt9","birthday":"Header_birthday__2K1R_","skeleton":"Header_skeleton__399Ip"};